import React from 'react';
import { FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function Status({
  label,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  onChange,
  disable,
  placeHolder,
  editingInput,
  showDelete,
  deleteItem,
  statusColours,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const activeStatus = statusColours?.find((ele) => ele.setDefault === true);

  const selectStyle = {
    ...customStyles,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '34px',
      border: '1px solid #848484',
      marginTop: '10px',
      backgroundColor: activeStatus?.colourHexCode,
      color: '#FFF',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      return { ...provided, opacity, color: '#000' };
    },
    option: (styles, { data, isSelected }) => {
      const foundStatus = statusColours?.find((status) => status.colourName === data.colourName);
      return {
        ...styles,
        color: isSelected ? '#000' : foundStatus?.colourHexCode,
        backgroundColor: isSelected ? foundStatus?.colourHexCode : 'white',
      };
    },
    valueContainer: (provided) => ({
      ...provided,
      alignItems: 'center',
      justifyContent: otherConfiguration?.alignment || 'center',
      fontWeight: otherConfiguration?.bold && 'bold',
    }),
  };
  const handleMenuOpen = () => {
    setParentGridZIndex(true, gridIndex);
  };

  const handleMenuClose = () => {
    setParentGridZIndex(false, gridIndex);
  };

  return (
    <FormGroup className="flex-fill position-relative select-min-height">
      <div className="custom-react-select-po">
        <p className={`mb-0 fs-custom-module field-lbl asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
        <Select
          name={`status_${gridIndex}_${pageIndex}`}
          options={statusColours}
          getOptionLabel={(option) => `${option?.colourName}`}
          getOptionValue={(option) => `${option?.colourHexCode}`}
          isDisabled={disable}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          onMenuOpen={handleMenuOpen}
          onMenuClose={handleMenuClose}
          styles={selectStyle}
          placeholder={placeHolder}
          value={activeStatus}
          onChange={(e) => onChange(e, label, gridIndex, pageIndex)}
        />

        {fromForm && onElement && (
          <CommonAction
            editingInput={editingInput}
            gridIndex={gridIndex}
            pageIndex={pageIndex}
            showDelete={showDelete}
            deleteItem={deleteItem}
            handleDuplicateItem={handleDuplicateItem}
            supplierVisible={supplierVisible}
            handleSupplierPermission={handleSupplierPermission}
            handleStaticGrid={handleStaticGrid}
            isStatic={isStatic}
          />
        )}
      </div>
    </FormGroup>
  );
}
export default Status;
